import type { EAttachesType } from 'reactApp/modules/attaches/attaches.constants';
import type { RequiredSignUpTouchSource } from 'reactApp/modules/requiredAuthorization/constants';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import type { ESearchOptionSource, ESearchOptionType } from 'reactApp/ui/WebSearch/WebSearch.data';

export enum EViewMode {
    thumbs = 'thumbs',
    list = 'list',
    gallery = 'gallery',
    galleryGrid3 = 'galleryGrid3',
    vkEmbeddedList = 'vkEmbeddedList',
    vkEmbeddedThumbs = 'vkEmbeddedThumbs',
    squares = 'squares',
    squares180 = 'squares180',
}

export enum EViewStoreType {
    photo = 'ui.photoView',
    photoMobile = 'ui.photoViewMobile',
    files = 'ui.filesView',
    attaches = 'ui.attachesView',
    quotaCleaner = 'ui.quotaCleanerView',
}

export interface SettingsState {
    viewMode: EViewMode;
    prevViewMode: EViewMode;
    viewModePhoto: EViewMode;
    viewModePhotoMobile: EViewMode;
    viewModeAttaches: EViewMode;
    viewModeQuotaCleaner: EViewMode;
    queryParams: QueryParams;
    sidebarOpened: boolean;
}

export interface QueryParams {
    query?: string;
    folderId?: string;
    productId?: string;
    tariffId?: string;
    weblink?: string;
    type?: EAttachesType;
    fromAuth?: boolean;
    sort?: string;
    item?: string;
    action?: string;
    diskoKey?: string;
    id?: string;
    searchType?: ESearchOptionType;
    searchSource?: ESearchOptionSource;
    token?: string;
    max_size?: number;
    total_size?: number;
    afterReload?: boolean;
    from?: string;
    /** Флаг, по которому определяем является ли аттач cloud_stock.
     *  Нужен для взаимодействия почты и облака внутри MailPopup
     */
    isCloudStock?: boolean;
    isAcceptanceLA?: boolean;
    /**
     * Максимальный размер аттача, при превышении которого откроется MailPopup
     * (2 ГБ для всех по умолчанию, но может быть и меньше в рамках экспа)
     */
    attach_size_limit?: string;
    // tempexp_17072-start
    /**
     * CLOUDWEB-17072 - флаг, по которому MailPopup должен сделать вид,
     * что он не умеет загружать файлы размером больше attach_size_limit
     */
    attach_size_limit_force?: '1';
    /** CLOUDWEB-17072 - имя группы для метрик */
    attach_size_limit_id?: string;
    // tempexp_17072-end
    fromCloud?: boolean;
    activeFolder?: string;
    activeItem?: string;
    dialog?: string;
    searchSection?: string;
    required_sign_up_touch_source?: RequiredSignUpTouchSource;
    isFromExternal?: string;
    utm_source?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_medium?: string;
    /**
     * CLOUDWEB-17241 - показываем окно с выбором тем при открытии паблика
     */
    // tempexp_17072-start
    themeChooser?: boolean;
    source?: string;
    // tempexp_17072-end
    fromLitres?: boolean;
    // tempexp_18086-next-line
    referral?: boolean;

    viewerOnly?: boolean;
    is_app_viewer?: boolean;
}

export interface ISetViewModeForStorageAction {
    viewMode: EViewMode;
    storage: EStorageType;
    isMediaFolder?: boolean;
}

export interface ISetViewModeAction {
    viewMode: EViewMode;
}
